import type { ResultDto } from "types/Result";

export enum ReportCommentsActionTypes {
	GET_SHARED_REPORT_COMMENTS_REQUEST = "@@reportComments/GET_SHARED_REPORT_COMMENTS_REQUEST",
	// get report comments
	GET_REPORT_COMMENTS_REQUEST = "@@reportComments/GET_REPORT_COMMENTS_REQUEST",
	GET_REPORT_COMMENTS_SUCCESS = "@@reportComments/GET_REPORT_COMMENTS_SUCCESS",
	GET_REPORT_COMMENTS_ERROR = "@@reportComments/GET_REPORT_COMMENTS_ERROR",
}

export interface ReportCommentsState {
	readonly results: Record<string, ResultDto>;
	readonly states: Record<
		string,
		{
			isLoading: boolean;
			hasLoaded: boolean;
			error: Error | null;
		}
	>;
}
